<script setup>
import { computed, inject } from 'vue';
import { useI18n } from 'vue-i18n';
import ColorField from '../../fields/ColorField.vue';
import SpacingField from '../../fields/SpacingField.vue';
import SliderField from '../../fields/SliderField.vue';
import VisibilityField from '../../fields/VisibilityField.vue';

const props = defineProps({
  node: { type: Object, required: true },
  // Elemento do rodapé fica sempre visível (o servidor força): sem o campo.
  selection: { type: Object, default: null },
});
const emit = defineEmits(['update']);
const ed = inject('emailEditor');
const { t } = useI18n();
const st = computed(() => props.node.style || {});
const style = (key, value) => emit('update', { style: { [key]: value } }, key);
</script>

<template>
  <div data-props="divider" class="flex flex-col gap-4">
    <SliderField
      :label="t('EMAIL_TEMPLATES.EDITOR.PROPS.THICKNESS')"
      :model-value="st.thickness"
      :min="1"
      :max="10"
      unit="px"
      @update:model-value="v => style('thickness', v)"
    />
    <label class="flex flex-col gap-1.5">
      <span class="text-xs font-medium text-n-slate-11">{{
        t('EMAIL_TEMPLATES.EDITOR.PROPS.LINE_STYLE')
      }}</span>
      <select
        class="rounded-lg border border-n-weak bg-n-solid-1 px-2 py-1.5 text-sm"
        :value="st.line_style"
        @change="style('line_style', $event.target.value)"
      >
        <option v-for="s in ['solid', 'dashed', 'dotted']" :key="s" :value="s">
          {{ t(`EMAIL_TEMPLATES.EDITOR.PROPS.LINE_STYLES.${s}`) }}
        </option>
      </select>
    </label>
    <ColorField
      :label="t('EMAIL_TEMPLATES.EDITOR.PROPS.COLOR')"
      :theme="ed.template.value?.theme || {}"
      :model-value="st.color"
      @update:model-value="v => style('color', v)"
    />
    <SliderField
      :label="t('EMAIL_TEMPLATES.EDITOR.PROPS.LINE_WIDTH')"
      :model-value="st.width"
      :min="5"
      :max="100"
      unit="%"
      @update:model-value="v => style('width', v)"
    />
    <SpacingField
      :label="t('EMAIL_TEMPLATES.EDITOR.PROPS.PADDING')"
      :model-value="st.padding"
      @update:model-value="v => style('padding', v)"
    />
    <VisibilityField
      v-if="selection?.row?.role !== 'footer'"
      :model-value="st.hide_on"
      @update:model-value="v => style('hide_on', v)"
    />
  </div>
</template>
